import api from '@/api/api.js'

export const RESOURCES_STORE_NAMESPACE = 'resources'

// Mutation names
const SET_SELECTED_RESOURCE_ID = 'setSelectedResourceId'

// Getter names
export const GET_SELECTED_RESOURCE_ID = 'getSelectedResourceId'

// Action names
export const SELECT_RESOURCE_WITH_ID = 'selectResourceWithId'
export const UPLOAD_DATA = 'uploadData'

// Users store implementation
export const ResourcesStore = {
  namespaced: true,

  state: () => ({
    // state must be a function to allow reuse of this store
    selectedResourceId: null
  }),

  mutations: {
    [SET_SELECTED_RESOURCE_ID]: (state, { resourceId }) => {
      state.selectedResourceId = resourceId
    }
  },

  getters: {
    [GET_SELECTED_RESOURCE_ID]: state => {
      return state.selectedResourceId
    }
  },

  actions: {
    [SELECT_RESOURCE_WITH_ID]: ({ commit }, { resourceId }) => {
      commit(SET_SELECTED_RESOURCE_ID, { resourceId })
    },

    [UPLOAD_DATA]: async (_, { resourceId, dataFile }) => {
      const formData = new FormData() // eslint-disable-line
      formData.append('fileContents', dataFile)

      return api.post(`admin/resources/${resourceId}/data`, formData)
    }
  }
}
